import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-cross-referencing-loader',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './cross-referencing-loader.component.html',
  styleUrls: ['../cross-referencing.component.scss'],
})
export class CrossReferencingLoaderComponent {}
